import React, { Component } from "react";
import HomeContactForm from "./homeContactForm";

class HomeContact extends Component {
  state = {};
  render() {
    return (
      <div className="container-fluid px-0 px-lg-3 py-2 pb-5" id="contact">
        <section className="section team-section pt-5 px-0">
          <h2 className="text-center my-3 font-weight-bold h1">Contact us</h2>
          <p className="text-center font-weight-bolder mb-5 w-responsive mx-auto">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit,
            error amet numquam iure provident voluptate esse quasi, veritatis
            totam voluptas nostrum quisquam eum porro a pariatur veniam.
          </p>
          <div className="card rgba-white-strong">
            <div className="row">
              <div className="col-lg-7 pr-lg-0">
                <div className="card-body form">
                  <h3 className="mt-4 text-dark">
                    <i className="fas fa-envelope p-2 pb-md-4"></i>Write to us:
                  </h3>
                  <div className="row">
                    <div className="col">
                      <HomeContactForm></HomeContactForm>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 pl-lg-0">
                <div className="z-depth-1-half overflow-hidden position-relative map-container">
                  <iframe
                    title="google-map"
                    className="w-100"
                    style={{ height: 450 }}
                    frameBorder="0"
                    src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJtxqdJooEfDkRzLsZHfWLsvc&key=AIzaSyD40tjm34_l_Jb_ISAisneZSoX9uCUOnjA"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default HomeContact;
